module.exports = __webpack_public_path__ + "img/lanzi.79c1f1a8.png";